import { EventContext, Fields } from '@vimeo/bigpicture-client';

import { createNullObject, PartialWithRequired } from './utils';

export const folderBpContextName = 'folder_context';
export const folderBpContextSchemaVersion = 1;
export type FolderBpContext = Fields<
  typeof folderBpContextName,
  typeof folderBpContextSchemaVersion
>;

const defaults = createNullObject([
  'access_permission_to_folder',
  'is_subfolder',
  'folder_share_status',
  'is_private_to_me',
  'parent_folder_id',
  'position_row',
  'is_pinned',
  'is_my_videos',
]);

export const buildFolderBpContext = (fields: PartialWithRequired<FolderBpContext, 'folder_id'>) => {
  return {
    folder_context: new EventContext(folderBpContextName, folderBpContextSchemaVersion, {
      ...defaults,
      ...fields,
    }),
  };
};
